import { useMetadataUser } from 'contexts/metadata-user-context'
import darkLayer from 'images/info.svg'
import layer from 'images/Layer 2.svg'

interface EmployeesNextPayment {
  employees: number | undefined
}

export default function EmployeesNextPayment({
  employees,
}: Readonly<EmployeesNextPayment>) {
  const { darkMode } = useMetadataUser()
  return (
    <section className="bg-[#F9FAFB] w-1/3  dark:bg-[#1F2937] rounded-3xl flex flex-col items-center p-5 gap-10">
      <span className="text-[#000000] dark:text-[#ffffff] font-bold text-3xl text-center">
        Estimativa do próximo pagamento
      </span>
      <div className="flex flex-col gap-20">
        <span
          className="text-[#000000] dark:text-[#ffffff] font-bold
        text-[80px] flex flex-col items-center pt-[70px]"
        >
          {`${Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(employees ?? 0)}`}
        </span>
        <div className="flex flex-nowrap px-4 py-4 items-center border-2 border-dashed border-[#017DC3] bg-[#54B9F280] rounded-3xl">
          <img
            className="pb-[45px]"
            src={!darkMode ? layer : darkLayer}
            alt="Layer dark"
          />
          <span className="text-[#000000] dark:text-[#ffffff] font-normal text-[15px] italic ml-2 text-left">
            Valor calculado considerando o número de colaboradores assinantes
            atual, o valor de coparticipação e valor dado em premiação.
          </span>
        </div>
      </div>
    </section>
  )
}
